// extracted by mini-css-extract-plugin
export default {"wrapper":"WedgesRecommendation_wrapper__Ljsm4"};